import { compose, withHandlers, withState } from 'recompose'
import { connect } from 'react-redux'
import ShopByTireSizeStatic from './ShopByTireSizeStatic'
import { SHOP_TIRES_TAB_NAME } from './constant'
import getActiveVehicle, { getIsActiveVehicleTrailer } from 'selectors/getActiveVehicle'
import { navigateToSearchByTireSizes } from 'actions/shopByTires'
import { showNewShopTiresModal } from '../NewShopTiresModal/actions'
import { getHasActiveVehicleStatus, getHasActiveVehicleWithTireSize } from 'selectors'
import { getLocationPathname } from 'selectors/getPageLocation'
import isTrailerTiresPage from 'helpers/isTrailerTiresPage'
import { YMME_NAME, TRAILER_SOURCE, TAB_TIRE_SIZE_NAME } from 'constant'
import withShowConfirmTireSizeModalPreconfigured from 'components/common/hoc/withShowConfirmTireSizeModalPreconfigured'
import withNavigateToTireSearchOrShowYmme from 'components/common/hoc/withNavigateToTireSearchOrShowYmme'
import { setVehicleDetails } from 'actions/confirmTireSize'
import withTrailerFlags from 'components/common/hoc/withTrailerFlags'

const mapStateToProps = (state) => ({
  activeVehicle: getActiveVehicle(state),
  hasActiveVehicle: getHasActiveVehicleStatus(state),
  isTrailer: getIsActiveVehicleTrailer(state),
  isTrailerTiresPage: isTrailerTiresPage(getLocationPathname(state)),
  hasActiveVehicleWithTireSize: getHasActiveVehicleWithTireSize(state)
})

const withTabsState = withState('tab', 'setTab', SHOP_TIRES_TAB_NAME)

const withGeneralHandlers = withHandlers({
  goToFrontTireSizeLastStep: ({ activeVehicle, showNewShopTiresModal, queryParams }) => () => {
    const { frontTireSize } = activeVehicle
    const [width, ratio] = frontTireSize.match(/\d+/g)
    const tireSizePreData = {
      front: {
        width: { value: width, label: width },
        ratio: { value: ratio, label: ratio },
        diameter: null
      },
      rear: {
        width: null,
        ratio: null,
        diameter: null
      }
    }

    showNewShopTiresModal({
      ymmeName: YMME_NAME,
      isOnlyTireSize: true,
      tabName: TAB_TIRE_SIZE_NAME,
      tireSizePreData,
      isRemoveRearSize: true,
      queryParams
    })
  }
})

const withShopByTireSizeStaticHandlers = withHandlers({
  setTabHandler: ({ setTab }) => (tabName) => {
    setTab(tabName)
  },
  editTireSizeHandler: ({ activeVehicle, showNewShopTiresModal, queryParams, goToFrontTireSizeLastStep }) => () => {
    const { rearTireSize = '', frontTireSize = '' } = activeVehicle
    const [frontWidth, frontRatio, frontDiameter] = frontTireSize.match(/\d+/g) || []
    const [rearWidth, rearRatio] = rearTireSize.match(/\d+/g) || []

    if (!rearTireSize) goToFrontTireSizeLastStep()

    if (rearTireSize) {
      const tireSizePreData = {
        front: {
          width: { value: frontWidth, label: frontWidth },
          ratio: { value: frontRatio, label: frontRatio },
          diameter: { value: frontDiameter, label: frontDiameter }
        },
        rear: {
          width: { value: rearWidth, label: rearWidth },
          ratio: { value: rearRatio, label: rearRatio },
          diameter: null
        }
      }

      showNewShopTiresModal({
        ymmeName: YMME_NAME,
        isOnlyTireSize: true,
        tabName: TAB_TIRE_SIZE_NAME,
        tireSizePreData,
        isEditRearSize: true,
        queryParams
      })
    }
  },
  addRearTireSizeHandler: ({ activeVehicle, showNewShopTiresModal, queryParams }) => () => {
    const { frontTireSize } = activeVehicle
    const [width, ratio, diameter] = frontTireSize.match(/\d+/g)
    const tireSizePreData = {
      front: {
        width: { value: width, label: width },
        ratio: { value: ratio, label: ratio },
        diameter: { value: diameter, label: diameter }
      },
      rear: {
        width: null,
        ratio: null,
        diameter: null
      }
    }

    showNewShopTiresModal({
      ymmeName: YMME_NAME,
      isOnlyTireSize: true,
      tabName: TAB_TIRE_SIZE_NAME,
      tireSizePreData,
      isAddRearSize: true,
      queryParams
    })
  },
  removeRearTireSizeHandler: ({ goToFrontTireSizeLastStep }) => () => {
    goToFrontTireSizeLastStep()
  },
  findMyTiresHandler: ({
    isTrailerTiresPage,
    showNewShopTiresModal,
    queryParams,
    hasActiveVehicle,
    activeVehicle,
    navigateToSearchByTireSizes,
    onClick,
    hasActiveVehicleWithTireSize
  }) => () => {
    if (isTrailerTiresPage) {
      showNewShopTiresModal({
        isOnlyTireSize: true,
        ymmeName: YMME_NAME,
        source: TRAILER_SOURCE,
        tabName: TAB_TIRE_SIZE_NAME
      })
    }

    if (!isTrailerTiresPage && !hasActiveVehicle) {
      showNewShopTiresModal({
        isOnlyTireSize: true,
        ymmeName: YMME_NAME,
        tabName: TAB_TIRE_SIZE_NAME,
        queryParams
      })
    }

    if (!isTrailerTiresPage && hasActiveVehicle && hasActiveVehicleWithTireSize) {
      navigateToSearchByTireSizes(activeVehicle, queryParams)
    }

    if (!isTrailerTiresPage && hasActiveVehicle && !hasActiveVehicleWithTireSize) {
      onClick()
    }
  }
})

export default compose(
  connect(mapStateToProps, { showNewShopTiresModal, navigateToSearchByTireSizes, setVehicleDetails }),
  withTabsState,
  withTrailerFlags,
  withNavigateToTireSearchOrShowYmme,
  withShowConfirmTireSizeModalPreconfigured,
  withGeneralHandlers,
  withShopByTireSizeStaticHandlers
)(ShopByTireSizeStatic)

